'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product order description
 */
    .directive('capOrderProductDescription', function () {
        return {
            restrict: 'A',
            scope: {
                productName: "=",
                productLogoResourcePath: "=",
                productLogoResourceAlt: "=",
                productDescription: "=",
                providerName: "=",
                hideProvider: "="
            },
            templateUrl: "templates/orderproductdescription.html"
        }
    });